const emailDesigner = {
  searchTemplates: "חיפוש תבניות...",
  allCategories: "כל הקטגוריות",
  newTemplate: "תבנית חדשה",
  templates: "תבניות",
  noTemplates: "אין תבניות",
  selectOrCreate: "בחר תבנית או צור חדשה",
  untitledTemplate: "תבנית ללא שם",
  defaultSubject: "נושא המייל",
  copy: "העתק",
  duplicate: "שכפול",
  delete: "מחיקה",
  subject: "נושא",
  subjectPlaceholder: "הזן נושא למייל...",
  insertVariable: "הוסף משתנה",
  mergeVariables: "משתנים דינמיים",
  variables: "משתנים",
  edit: "עריכה",
  preview: "תצוגה מקדימה",
  previewMode: "מצב תצוגה מקדימה",
  previewHint: "משתנים מוצגים עם ערכי דוגמה",
  catSystem: "מערכת",
  catTransactional: "טרנזקציוני",
  catMarketing: "שיווק",
} as const;
export default emailDesigner;
